export default __webpack_public_path__ + "static/media/blue-star.14b99272.svg";